import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var CogSVG = function CogSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.84 13.44h-.11l-3.17-.36a9.12 9.12 0 00-.72-1.74l2-2.5.07-.09a1.51 1.51 0 00-.21-1.85l-1.58-1.59a1.53 1.53 0 00-1.85-.21l-.09.07-2.5 2a9.12 9.12 0 00-1.74-.72l-.36-3.17v-.11A1.52 1.52 0 0017.11 2h-2.22a1.52 1.52 0 00-1.46 1.16v.11l-.36 3.17a9.12 9.12 0 00-1.74.72l-2.49-2-.11-.06a1.53 1.53 0 00-1.85.21L5.31 6.88a1.51 1.51 0 00-.21 1.85l.07.09 2 2.49a9.12 9.12 0 00-.72 1.74l-3.17.36h-.11A1.5 1.5 0 002 14.89v2.22a1.52 1.52 0 001.16 1.46h.11l3.17.36a10.27 10.27 0 00.72 1.74l-2 2.5-.07.09a1.51 1.51 0 00.21 1.85l1.57 1.57a1.54 1.54 0 001.06.43 1.47 1.47 0 00.79-.22l.09-.07 2.5-2a10.27 10.27 0 001.74.72l.36 3.17v.11A1.52 1.52 0 0014.89 30h2.22a1.52 1.52 0 001.46-1.16v-.11l.36-3.17a10.27 10.27 0 001.74-.72l2.5 2 .09.07a1.47 1.47 0 00.79.22 1.54 1.54 0 001.06-.43l1.57-1.57a1.51 1.51 0 00.21-1.85l-.07-.09-2-2.5a10.27 10.27 0 00.72-1.74l3.17-.36h.11A1.52 1.52 0 0030 17.11v-2.22a1.5 1.5 0 00-1.16-1.45zM16 19a3 3 0 113-3 3 3 0 01-3 3z"
  }));
};
CogSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CogSVG);